module.exports = __webpack_public_path__ + "img/case-logo-24.aedd2c81.png";